import React, { useState } from 'react';
import { withPreview } from '../decorators/withPreview';
import { PasswordTextBox, PasswordTextBoxProps } from './PasswordTextBox';
import { useTranslationAPI } from '../../modules/translations';
import { FlexGrid, FlexGridColumn } from '../FlexGrid';
import { blue } from '../Color';
import { CopyToClipboard } from '../CopyToClipboard';
import { translationCodes } from '../../data/translations/translationModuleCodes';
import { isUndefined } from '../../predicates/type';
import { IconButton } from '../IconButton';
import classes from './styles/passwordPreview.module.scss';
import { Copy } from '../Icons/Copy';
import { Visibility } from '../Icons/Visibility';
import { Typography } from '../Typography';

const PasswordPreviewFormat = ({ value }: PasswordTextBoxProps) => {
	const { translate } = useTranslationAPI();
	const [isPasswordVisible, setIsPasswordVisible] = useState(false);

	const formattedValue = () => {
		return isPasswordVisible ? value : Array(9).fill('•').join('');
	};

	return (
		<FlexGrid
			center
			spaceBetween
		>
			<FlexGridColumn
				grow
				wrappedText
			>
				<Typography truncated>{formattedValue()}</Typography>
			</FlexGridColumn>
			<FlexGrid gap={'tiny'}>
				<IconButton
					onClick={() => setIsPasswordVisible((prevState) => !prevState)}
					dataTestId='passwordPreviewVisibilityButton'
					link
					className={classes.icon_button}
				>
					<Visibility fill={isPasswordVisible ? blue[5] : undefined} />
				</IconButton>
				{!isUndefined(value) && (
					<CopyToClipboard
						value={value}
						afterCopySuccessMessage={translate(translationCodes.copiedToClipBoard)}
						render={({ onCopyButtonClick }) => (
							<IconButton
								onClick={onCopyButtonClick}
								dataTestId='passwordPreviewCopyButton'
								link
								className={classes.icon_button}
							>
								<Copy />
							</IconButton>
						)}
					/>
				)}
			</FlexGrid>
		</FlexGrid>
	);
};

export const PasswordTextBoxWithPreview = withPreview<PasswordTextBoxProps>(PasswordTextBox, PasswordPreviewFormat);
